export default {
  selectedProjectDetails: {},
  addOnType: "",
};
